import React from "react";
import AutoTransactionContainer from "../../containers/Transaction/AutoTransaction";

function AutoTransaction(props) {
  return <AutoTransactionContainer {...props} />;
}

export default AutoTransaction;
